import { Select } from '@consta/uikit/Select'
import type { TextPropSize, TextPropView } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import type { AlgorithmParams, StickSeparationParams } from '@core/core/types'
import type { FC } from 'react'

import { numberOfLeafsItems } from '../../../constants'
import { isStickSeparationParams } from '../../../helpers'
import css from '../Algorithm.css'
import { handleValueChange } from '../helpers'

type StickSeparationProps = {
  algorithm: AlgorithmParams
  textProps?: { size: TextPropSize; view: TextPropView }
  handleChange: (field: keyof StickSeparationParams, value: string | number | boolean) => void
}

export const StickSeparation: FC<StickSeparationProps> = ({
  algorithm,
  textProps,
  handleChange,
}) => {
  isStickSeparationParams(algorithm)

  return (
    <div className={css.input}>
      <Text {...textProps}>Кол-во листьев в графе</Text>
      <Select
        size="xs"
        items={numberOfLeafsItems}
        value={numberOfLeafsItems.find(item => item.id === algorithm.numberOfLeafs)}
        onChange={value => {
          handleValueChange<StickSeparationParams>(handleChange, 'numberOfLeafs', value?.id)
        }}
      />
    </div>
  )
}
